/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-usp component
 */

@use "../zr-css-icon/zr-css-icon.scss" as i;
@use "../zr-theme/functions/fonts" as f;
@use "../zr-theme/fonts/open-sans.scss";

// component name
$component: 'zr-usp';

// component vars defaults
:host {
    --zr-usp-gutter: 16px;
    --zr-usp-font-size: var(--ci-font-size-px);
    font-size: var(--zr-usp-font-size);
}

.#{$component} {
    font-family: 'Open Sans', sans-serif;
    padding: var(--zr-usp-gutter) 0;
    border: solid 1px var(--ci-neutral300);
    border-radius: 4px;
    color: var(--ci-neutral900);
}

.#{$component}__list {
    margin-bottom: 0;
    padding: 0 var(--zr-usp-gutter);
}

.#{$component}__list-item p{
    font-size: f.calc-em(14);
    padding-left: 36px;
    position: relative;

    &::before {
        position: absolute;
        left: 0;
        top: calc(50% - 14px);
    }
}

.#{$component}__list-item {
    list-style: none;
    display: block;
    margin-top: var(--zr-usp-gutter);

    &:first-child,
    p {
        margin: 0;
    }
}

.#{$component}__icon--van {
    @include i.get-icon-left(van);
}

.#{$component}__icon--card {
    @include i.get-icon-left(card);
}

.#{$component}__icon--rewe-pin {
    @include i.get-icon-left(rewe-pin);
}

.#{$component}__icon--package {
    @include i.get-icon-left(package);
}
